import { render, staticRenderFns } from "./NetPaNav.vue?vue&type=template&id=08ff978b&scoped=true&"
import script from "./NetPaNav.vue?vue&type=script&lang=js&"
export * from "./NetPaNav.vue?vue&type=script&lang=js&"
import style0 from "./NetPaNav.vue?vue&type=style&index=0&id=08ff978b&scoped=true&lang=css&"
import style1 from "./NetPaNav.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ff978b",
  null
  
)

export default component.exports